/**
 * Шапка лежит поверх первого экрана (absolute); после прокрутки ниже своей
 * высоты — прилипает к верху (is-fixed, белый фон), как на боевом сайте.
 * scrollTo.js берёт отступ якорей из её высоты, если она absolute/fixed.
 */
itsoftApp.createModule("headerFix", ["pageLoad", "windowScroll"], function () {
    const module = this;

    const header = document.querySelector(".js-header");

    if (!header) {
        return false;
    }

    const FIXED = "is-fixed";
    let fixed = false;

    const update = function (scrollY) {
        const next = scrollY > header.offsetHeight;

        if (next !== fixed) {
            fixed = next;
            header.classList.toggle(FIXED, fixed);
        }
    };

    update(window.pageYOffset);
    itsoftApp.modules.windowScroll.addEvent(function () {
        update(window.pageYOffset);
    });

    module.callback = { update: update };
});
